import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=a91c7464&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=a91c7464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91c7464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a91c7464')) {
      api.createRecord('a91c7464', component.options)
    } else {
      api.reload('a91c7464', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=a91c7464&scoped=true&", function () {
      api.rerender('a91c7464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KloDoSH3Xtbk/JS/comp/CookieBox.vue"
export default component.exports